/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconGrave = createReactComponent("grave", "IconGrave", [
  [
    "path",
    { d: "M5 21v-2a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v2h-14z", key: "svg-0" }
  ],
  ["path", { d: "M10 16v-5h-4v-4h4v-4h4v4h4v4h-4v5", key: "svg-1" }]
]);

export { IconGrave as default };
//# sourceMappingURL=IconGrave.js.map
